import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './content.module.scss';

@classic
@classNames(styles.component)
export default class SharedFullFlyoutContent extends Component {}
